import { SmCard } from '@spo/storybook';
import { SpoPosterTableResponseItemSmSegmentationNeedColumnsItemNeedSegmentationSmColumnsItem } from '@spo/types';
import { format } from 'date-fns';
import { buildLegacyUrl } from '../../../utils/legacyUrl';
import { ProductBenefits } from '../../productBenefits';
import './thirdLevel.scss';

export const ThirdLevel = ({
  content,
}: {
  content: SpoPosterTableResponseItemSmSegmentationNeedColumnsItemNeedSegmentationSmColumnsItem;
}) => {
  const goToSmPage = () => {
    const beginDate = format(content.smCard.startDate, 'yyyy-MM-dd');
    const endDate = format(content.smCard.endDate, 'yyyy-MM-dd');
    window.open(
      buildLegacyUrl(content.smCard.id, beginDate, endDate),
      '_blank',
    );
  };
  return (
    <div data-testid="third-level" className="third-level">
      <ProductBenefits benefits={content.benefits} />
      <SmCard
        key={content.smCard.id}
        sm={content.smCard}
        navigateActionButton={goToSmPage}
      />
    </div>
  );
};
